module.exports = __webpack_public_path__ + "img/3.2566db5f.png";